import { useState } from 'react';
import { useEffectAsync } from '../../../helpers';
import apiClient from '../../../Services/ApiClient';
import useLoading from '../../Base/Hooks/useLoading';
import useApiClient from '../../Base/Hooks/useApiClient';

export default function useP1Patient(patientId: string) {
	const { setIsLoading, isLoading } = useLoading(true);
	const [isPatientValid, setIsPatientValid] = useState(false);
	const { displayError } = useApiClient();

	//CHECK PATIENT DATA VALIDITY
	useEffectAsync(async () => {
		try {
			const response = await apiClient.get(`/p1/erecept/validate/${patientId}`);
			setIsPatientValid(response.status === 200);
		} catch (e) {
			displayError(e);
		}
		setIsLoading(false);
	}, []);

	return {
		isLoadingP1Patient: isLoading,
		isPatientValid,
	};
}
